import {connect} from 'react-redux';
import {SliderGroup as Component} from './SliderGroup';
import {selectNewSequenceInGroup} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    changeHighlight: (params) => {
      dispatch(selectNewSequenceInGroup(params));
    },
  };
}

export const SliderGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
